<template>
  <el-card class="medaiaList" :body-style="{ width: '100%', boxSizing: 'border-box', padding: '0 5px' }">
    <div class="wrapperMediaList">
      <div class="textMediaList">Media list</div>
      <template v-for="(item, index) in value">
        <el-col :key="index">
          <media-list
            :item="item"
            :index="index"
            :info="item"
            :video-info="videoInfo"
            @deleteRange="removeElement(index)"
            @preview="previewVideoSegment(item.ranges, index)"
            @selectVideoId="shoiceVideoId"
          />
        </el-col>
      </template>
    </div>
  </el-card>
</template>

<script src="vue-slicksort/dist/umd/vue-slicksort.js"></script>
<script>
import MediaList from "./MediaList";
import { ContainerMixin } from "vue-slicksort";

export default {
  name: "MediaEditList",
  components: {
    MediaList
  },
  mixins: [ContainerMixin],
  props: {
    videoInfo: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      deleteRangeVideoSelect: [],
      mediaCutsInfo: []
    };
  },
  computed: {
    imageMediaList() {
      return this.mediaCuts.map(e => e.thumbnailLink);
    }
  },
  watch: {
    deleteRangeVideoSelect() {
      this.mediaCutsInfo = this.mediaCutsInfo.filter(
        e => e.ranges != this.deleteRangeVideoSelect
      );
    }
  },
  methods: {
    removeElement(index) {
      this.$emit("removeVideoIndex", index);
    },
    previewVideoSegment(range, index) {
      this.$emit("previewRange", { range, index });
    },
    shoiceVideoId(idVideo) {
      // this.$emit("selectVideoId", idVideo);
    }
  }
};
</script>

<style>
.el-card.medaiaList{
  background: #aaaaaa;
}
.textMediaList {
  /* font-family: sans-serif; */
  padding: 10px;
  text-align: start;
  color: #000;
}
</style>
